import { NoteCheckOutlineIcon } from './NoteCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 827B10E4-F154-4101-BB5C-492EA37B7D08
 * name note-check-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-check-outline.svg
 * tags
 */
export const PaperCheckOutlineIcon = NoteCheckOutlineIcon;
export default PaperCheckOutlineIcon